var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMock2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 364.93 331.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#f3faff;}.cls-3{fill:#e5dcff;opacity:0.8;}.cls-100,.cls-3,.cls-4,.cls-67,.cls-69,.cls-77,.cls-80,.cls-81,.cls-82,.cls-84,.cls-87,.cls-89,.cls-90,.cls-93,.cls-97,.cls-99{mix-blend-mode:multiply;}.cls-5{fill:#d1d3d4;}.cls-6{fill:#3387cc;}.cls-7{fill:#6cb1f7;}.cls-8,.cls-99{fill:#b38ff7;}.cls-9{fill:#fff;}.cls-10{fill:#cfe9ff;}.cls-11{fill:#ffcacf;}.cls-12,.cls-69{fill:#ffce55;}.cls-100,.cls-13{fill:#00a79d;}.cls-14{fill:#5fc8d7;}.cls-15{fill:#f7941d;}.cls-16{fill:#ef4065;}.cls-17{fill:#f5333f;}.cls-18{fill:#fefefe;}.cls-19{fill:#fdfdfd;}.cls-20{fill:#fcfcfc;}.cls-21{fill:#fbfbfb;}.cls-22{fill:#fafafa;}.cls-23{fill:#f9f9fa;}.cls-24{fill:#f8f8f9;}.cls-25{fill:#f7f8f8;}.cls-26{fill:#f6f7f7;}.cls-27{fill:#f5f6f6;}.cls-28{fill:#f4f5f5;}.cls-29{fill:#f3f4f4;}.cls-30{fill:#f2f3f3;}.cls-31{fill:#f1f2f2;}.cls-32{fill:#f0f1f1;}.cls-33{fill:#eff0f0;}.cls-34{fill:#eeefef;}.cls-35{fill:#edeeef;}.cls-36{fill:#ecedee;}.cls-37{fill:#ebeced;}.cls-38{fill:#eaebec;}.cls-39{fill:#e9eaeb;}.cls-40{fill:#e8e9ea;}.cls-41{fill:#e8e9e9;}.cls-42{fill:#e7e8e8;}.cls-43{fill:#e6e7e7;}.cls-44{fill:#e5e6e6;}.cls-45{fill:#e4e5e5;}.cls-46{fill:#e3e4e4;}.cls-47{fill:#e2e3e4;}.cls-48{fill:#e1e2e3;}.cls-49{fill:#e0e1e2;}.cls-50{fill:#dfe0e1;}.cls-51{fill:#dedfe0;}.cls-52{fill:#dddedf;}.cls-53{fill:#dcddde;}.cls-54{fill:#dbdcdd;}.cls-55{fill:#dadbdc;}.cls-56{fill:#d9dadb;}.cls-57{fill:#d8dada;}.cls-58{fill:#d7d9d9;}.cls-59{fill:#d6d8d9;}.cls-60{fill:#d5d7d8;}.cls-61{fill:#d4d6d7;}.cls-62{fill:#d3d5d6;}.cls-63{fill:#d2d4d5;}.cls-64{fill:#f8e4d2;}.cls-65{fill:#006838;}.cls-66,.cls-67{fill:#bb4738;}.cls-100,.cls-67,.cls-69,.cls-77,.cls-80,.cls-81,.cls-82,.cls-84,.cls-87,.cls-88,.cls-89,.cls-90,.cls-93,.cls-97,.cls-99{opacity:0.5;}.cls-68,.cls-87{fill:#ffbba6;}.cls-70{fill:#00b25c;}.cls-71{fill:#fffdeb;}.cls-72,.cls-82{fill:#fee0cf;}.cls-73,.cls-80{fill:#0b5f99;}.cls-74{fill:#647fa0;}.cls-75,.cls-77{fill:#7991b4;}.cls-76{fill:#a2c4ed;}.cls-78{fill:#ffe7c4;}.cls-79{fill:#ffc9ae;}.cls-81{fill:#f4e0cb;}.cls-83,.cls-84{fill:#f16680;}.cls-85,.cls-89{fill:#594a42;}.cls-86,.cls-90{fill:#877f7d;}.cls-88{fill:#fc957a;}.cls-91,.cls-93{fill:#ddc2bf;}.cls-92{fill:#fce2e0;}.cls-94{fill:#059147;}.cls-95{fill:#db3931;}.cls-96,.cls-97{fill:#9d2e24;}.cls-98{fill:#8c67e8;}.cls-101{fill:#a59c9a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M156.5,37.08c15.23,11.05,33.72,19.83,51.64,15.38,24.52-6.1,39.69-34.66,64-41.47,24.78-6.92,50,11.38,65.2,33.47,11.21,16.3,19.33,37.69,12.61,56.62-7.5,21.14-31.64,34-33.19,56.56-1.17,16.9,11.15,31.07,22.85,42.47s24.63,24.43,25.26,41.36c.47,12.59-6.22,24.28-14.33,33.39-16.64,18.7-42.31,30-65.41,22.59C261,289.68,241.75,263,216.64,266c-15.12,1.8-26.94,14.11-38.87,24.23-28.51,24.19-64.07,38.7-100.37,40.95-15.68,1-32.18-.52-45.55-9.36C12.52,309,3.6,280.71,11.73,258c7.48-20.9,14.65-34.11,21.89-55.12,7.36-21.38-6.06-37.71-20.59-52C2.26,140.27-4.53,122.65,3.55,103.73c6.12-14.31,25.36-16.11,23-35.18-1.23-10-8.12-18.3-6.7-28.78,2.52-18.48,20.47-31.3,36-36.06,19.36-5.95,43.56-5,61.69,4.92C131.59,16.35,143.5,27.65,156.5,37.08Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 34.44,
    cy: 298.91,
    rx: 28.26,
    ry: 7.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M321.84,290.12c0,4-12.65,7.2-28.26,7.2s-28.26-3.22-28.26-7.2,12.65-7.19,28.26-7.19S321.84,286.15,321.84,290.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.64,276.8c-12.57,0-23.21,1.2-26.88,2.86-3.37-1.13-11.07-1.92-20-1.92-12.07,0-21.85,1.43-21.85,3.19s9.78,3.2,21.85,3.2c9,0,16.68-.79,20-1.92,3.67,1.65,14.31,2.85,26.88,2.85,15.61,0,28.26-1.85,28.26-4.13S206.25,276.8,190.64,276.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 52.95,
    y: 75.99,
    width: 249.57,
    height: 151.17,
    rx: 15.17
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 52.95,
    y: 75.99,
    width: 249.57,
    height: 151.17,
    rx: 15.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 72.95,
    y: 84.05,
    width: 216.24,
    height: 135.05,
    rx: 7.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M68.2,151.57a5.08,5.08,0,1,1-5.08-5.08A5.07,5.07,0,0,1,68.2,151.57Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 82.93,
    y: 92.49,
    width: 197.49,
    height: 117.36,
    rx: 6.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M273.8,92.49H89.56a6.62,6.62,0,0,0-6.63,6.62v11.17H280.42V99.11A6.62,6.62,0,0,0,273.8,92.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M243.53,144.42c-7.65.19-13.33-6.89-20.39-9.86-9-3.79-20-.22-26.61,7-3.12,3.39-5.92,7.79-10.45,8.57-6.46,1.12-11.68-5.8-18.19-6.52-9.64-1.08-15.88,11.17-25.45,12.72-8.68,1.42-17.65-6.41-25.74-3-3.52,1.5-5.86,4.81-8.72,7.34s-7.21,4.35-10.41,2.26v12.68H266.71V132.25C258.87,135.77,252.13,144.2,243.53,144.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M110.16,191a6.06,6.06,0,1,1-6-6.06A6.05,6.05,0,0,1,110.16,191Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 115.51,
    y: 187.72,
    width: 58.65,
    height: 6.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 208.07,
    y: 182.02,
    width: 58.65,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 208.07,
    y: 189.34,
    width: 58.65,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 208.07,
    y: 196.66,
    width: 58.65,
    height: 3.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 97.57,
    y: 117.64,
    width: 29.58,
    height: 19.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M272,101.38A3.44,3.44,0,1,1,268.61,98,3.43,3.43,0,0,1,272,101.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M244.26,101.38A3.44,3.44,0,1,1,240.83,98,3.43,3.43,0,0,1,244.26,101.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M258.35,101.38A3.44,3.44,0,1,1,254.91,98,3.44,3.44,0,0,1,258.35,101.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 32.63,
    y: 35.74,
    width: 23.34,
    height: 23.34,
    rx: 3.48
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.85,52.44l-4.37-4.37a1.32,1.32,0,0,1,1.86-1.87l2.51,2.52,6-6a1.32,1.32,0,0,1,1.86,0,1.3,1.3,0,0,1,0,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M144.63,127.1l-3.55,9.1a10,10,0,0,0,3.3.56,10.14,10.14,0,0,0,9.8-7.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M144.55,126.24l9.8,2.16a9.8,9.8,0,0,0-.34-4.85,10.11,10.11,0,0,0-17.49-3.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M143.88,126.77,136,120.89a10.14,10.14,0,0,0,4.28,15Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 184.38,
    y: 132.36,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 184.56,
    y: 132.18,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 184.75,
    y: 131.99,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 184.93,
    y: 131.81,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 185.12,
    y: 131.62,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 185.3,
    y: 131.44,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 185.49,
    y: 131.25,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 185.67,
    y: 131.07,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 185.86,
    y: 130.88,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 186.04,
    y: 130.7,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 186.23,
    y: 130.51,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 186.41,
    y: 130.33,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 186.6,
    y: 130.14,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 186.78,
    y: 129.96,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 186.97,
    y: 129.77,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 187.15,
    y: 129.59,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 187.34,
    y: 129.4,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 187.52,
    y: 129.22,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 187.71,
    y: 129.03,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 187.89,
    y: 128.85,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 188.08,
    y: 128.66,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 188.26,
    y: 128.48,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 188.45,
    y: 128.29,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 188.63,
    y: 128.11,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 188.82,
    y: 127.92,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 189,
    y: 127.74,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 189.19,
    y: 127.55,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 189.37,
    y: 127.37,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 189.56,
    y: 127.18,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 189.74,
    y: 127,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 189.93,
    y: 126.81,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 190.11,
    y: 126.63,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 190.3,
    y: 126.44,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 190.48,
    y: 126.26,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 190.67,
    y: 126.07,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 190.85,
    y: 125.89,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 191.04,
    y: 125.7,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 191.22,
    y: 125.52,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 191.41,
    y: 125.33,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 191.59,
    y: 125.15,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 191.78,
    y: 124.96,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 191.96,
    y: 124.78,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 192.15,
    y: 124.59,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 192.33,
    y: 124.41,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 192.52,
    y: 124.22,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 192.7,
    y: 124.04,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 192.89,
    y: 123.85,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 193.07,
    y: 123.67,
    width: 125.5,
    height: 90.6,
    rx: 6
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 193.07,
    y: 123.67,
    width: 125.5,
    height: 90.6,
    rx: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 203.45,
    y: 150.76,
    width: 104.75,
    height: 53.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M216,136.16a6.27,6.27,0,1,1-6.26-6.26A6.26,6.26,0,0,1,216,136.16Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 222.97,
    y: 130.42,
    width: 44.01,
    height: 4.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 222.97,
    y: 140.05,
    width: 72.8,
    height: 1.86
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "265.62 177.33 249 169.16 249 185.51 265.62 177.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M142.86,271.1a11.52,11.52,0,0,0-2.36,3.67c-.4,1.55-.62,2.17-1.29,2a78.93,78.93,0,0,1-8.63-4c-1.78-1.11,4.19-.91,6.65-.64s4.06-2.26,4.06-2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M140.5,274.77a4,4,0,0,1,.34-.86,2,2,0,0,0-1.63-.21c-1.35.58-4.25-1.06-5.23-1.79-2.35-.05-4.58.1-3.4.84a78.93,78.93,0,0,0,8.63,4C139.88,276.94,140.1,276.32,140.5,274.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M192.43,246.26s-.17,9.89-17.41,9.1c-10.63-.22-16-2.26-16-2.26s-9.8,13.64-16.87,19L140,270.9s12.16-23,15.52-25c2.58-1.38,25.63-2,25.63-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M151.79,250.48a48.38,48.38,0,0,1,1.05,10.66c3.56-4.32,6.23-8,6.23-8a22.64,22.64,0,0,0,2.65.75c.27-2,.83-6,1-6.6a8.35,8.35,0,0,0,.3-2.42c-3.67.29-6.68.66-7.52,1.11S153.35,248.14,151.79,250.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M153.83,272.88a11.53,11.53,0,0,0-.41,4.34c.36,1.56.46,2.21-.22,2.37a76.67,76.67,0,0,1-9.52.41c-2.08-.16,3.31-2.73,5.62-3.63s2.55-3.88,2.55-3.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M194.22,246.62s2.68,6.48-2,9.78-29.21-3-29.21-3-.2,10.62-9.36,21l-2.58-.8s5.31-22.9,8.61-27.66c5.75-2.08,21.42-2,21.42-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M153.42,277.22a5.18,5.18,0,0,1-.1-.92c-.46.07-1.06,0-1.53.57-.93,1.13-4.26,1-5.47.82-2.11,1-4,2.21-2.64,2.31a76.67,76.67,0,0,0,9.52-.41C153.88,279.43,153.78,278.78,153.42,277.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M192.26,256.4c4.64-3.3,2-9.78,2-9.78l-13.08-2.69s-1.39,0-3.49,0c.12.58,7,5,7.58,7.68s-20.21.27-22.18,1.74C163.05,253.39,187.62,259.7,192.26,256.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M162.22,233.72a3.3,3.3,0,0,1-1.55.08c-.58-.2-1.61-.91-2.56-.68s-2,2.06-2.46,2.63,1.35,0,2.24-.6,1.52.86,2.52.72,2.32-.45,2.32-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M185.5,212.56a4.67,4.67,0,0,0-5.68,3.73c-.21,1.24-.44,2.46-.7,3.65-.29,1.41-.63,2.79-1,4.06-.19.65-.41,1.25-.61,1.77l-.15.36c-.3.73-.71.93-1.41,1.31s-1.26.65-1.92,1c-1.32.63-2.68,1.23-4.06,1.81-2.76,1.15-5.58,2.25-8.4,3.28l.61,2.5c3-.41,6-.88,9.08-1.44,1.51-.28,3-.58,4.57-.94.76-.17,1.54-.37,2.33-.59.4-.12.78-.22,1.2-.37l.62-.21.31-.11c.15-.07.38-.21.57-.32a7.54,7.54,0,0,0,1.05-.78l.64-.67.31-.34.22-.3.45-.6a26,26,0,0,0,1.42-2.28c.84-1.49,1.54-2.94,2.2-4.4.57-1.26,1.1-2.5,1.61-3.74A4.69,4.69,0,0,0,185.5,212.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M182.54,230.39l.31-.4.22-.34.45-.69c.55-.9,1-1.77,1.42-2.62.84-1.71,1.54-3.37,2.2-5.05.57-1.44,1.1-2.86,1.61-4.29a7.19,7.19,0,0,0,.24-.88,4.67,4.67,0,0,0-9.17.17c-.21,1.24-.44,2.46-.7,3.65-.29,1.41-.63,2.79-1,4.06-.19.65-.41,1.25-.61,1.77l-.15.36c-.3.73-.71.93-1.41,1.31h0a31.83,31.83,0,0,1,1,5.9c.42-.11.83-.2,1.26-.32s.78-.22,1.2-.37l.62-.21.31-.11c.15-.07.38-.21.57-.32l.41-.28a5.58,5.58,0,0,0,.64-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M168,239.86a3.3,3.3,0,0,1-1.55.08c-.58-.2-1.61-.92-2.55-.69s-2,2.07-2.47,2.64,1.35,0,2.24-.6,1.52.86,2.52.72,2.32-.45,2.32-.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M204.77,268V258h1.68v-1.53H170.86a5.25,5.25,0,0,0-5.24,5.24v2.65a5.24,5.24,0,0,0,5.24,5.23h35.59V268Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M193.42,232.7c.3-4.31.79-8.72.25-13-.41-3.31-2.31-6.84-5.78-7.66a6.09,6.09,0,0,0-4.76.85,25.48,25.48,0,0,0-2.17,1.49c-2.61,1.95-6.1,5.95-5.26,9.78a10.1,10.1,0,0,0,2.36,4.65,9.57,9.57,0,0,1,2,5.83c0,.64-1.12,7.48-2,8.72a.35.35,0,0,0,.09.49c3.1,2.25,10.27,7.32,17.59,4.49C196,245.81,192.94,239.54,193.42,232.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M171.58,258a4.13,4.13,0,0,0-4.12,4.13v1.81a4.12,4.12,0,0,0,4.12,4.12h34.07V258Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M173.67,279.54V271.1H172v-1.54h35.59a5.25,5.25,0,0,1,5.24,5.24v1a5.24,5.24,0,0,1-5.24,5.24H172v-1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M206.86,271.1a4.12,4.12,0,0,1,4.12,4.12v.2a4.12,4.12,0,0,1-4.12,4.12H172.79V271.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M181,197.64c-2.55.09-5.27,1.2-5.34,3.53-.09,3.09.92,4,.92,5a20,20,0,0,1-.44,2.31c0,.29,1.51-.14,1.7.16s1.75,2.38,3.11,2.26c1.76-.16,3.5-1.94,4.37-3.25,1.65-2.5,2.19-7.62-.93-9.34A6.83,6.83,0,0,0,181,197.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M186.86,212.42a9.3,9.3,0,0,1-2.25-6.2s-2.87.09-2.25,1.67.1,5.29.1,5.29-3.71,3-1.57,3.62c1.88.51,4.8-1.81,6-3.34A.8.8,0,0,0,186.86,212.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M174.5,202.73s.13.86,4.68.66c1.52-.28,1.35,2,1.81,3.57.35,1.2.9-.67,2-2.2s2.14,1.39.76,2.26,1.07,4.58-3.05,6.21c1.78.81,5.78-.36,8.69-2.59s-.89-11.39-3-13.53S173.66,194.06,174.5,202.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 153.24,
    y: 243.53,
    width: 20.79,
    height: 2.06
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "141.81 231.98 155.01 231.98 162.42 245.59 149.22 245.59 141.81 231.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M152.59,238.86c.36.92.14,1.66-.48,1.66s-1.42-.74-1.78-1.66-.15-1.67.48-1.67S152.23,237.94,152.59,238.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M149.22,245.6h13.2l-1.81-3.34a20.91,20.91,0,0,1-15.38-4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "180.57 262.87 183.57 262.87 182.16 264.14 180.57 262.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "192.41 273.13 195.4 273.13 194 274.4 192.41 273.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "195.63 264.14 200.34 264.14 198.13 266.13 195.63 264.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "177.76 274.32 182.47 274.32 180.26 276.31 177.76 274.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "171.53 259.73 175.42 259.73 173.59 261.38 171.53 259.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "202.21 276.85 206.1 276.85 204.28 278.5 202.21 276.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M183.07,218.92s.46,7,1.09,10.44c.5,2.67-1.76,4.65-4.19,5.83-.11.88-.4,2.56-.75,4.19,3.88-.78,11.21-2.31,11.22-2.87,0-.77,1.19-8.32.65-9.94S183.87,218.83,183.07,218.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M193.42,232.7c0-.16,0-.31,0-.46a6,6,0,0,0-2.23-.21c-.3.28-7.63,8.57-10,9.67,0,0,8.85-1.71,10-1s3,5.07,2.43,8.22a13.24,13.24,0,0,0,2-.57C196,245.81,192.94,239.54,193.42,232.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M193,225.16c-.27-2.12-.58-4.19-.95-6.25a4.57,4.57,0,1,0-8.81,2.32c.63,1.84,1.22,3.69,1.74,5.52a49.86,49.86,0,0,1,1.18,4.92,10.17,10.17,0,0,1,.17,1.14,7.76,7.76,0,0,1,.09,1l0,.22a.34.34,0,0,0,0,.1v.09a7.48,7.48,0,0,1-1.2.7,23.63,23.63,0,0,1-2.26.91c-1.61.56-3.32,1-5.05,1.44-3.46.82-7.05,1.48-10.61,2l.18,3.06c3.73,0,7.42,0,11.17-.35a57.16,57.16,0,0,0,5.7-.7,30.05,30.05,0,0,0,3-.68,12.13,12.13,0,0,0,3.35-1.51,5.71,5.71,0,0,0,2-2.37,3,3,0,0,0,.23-.65l.16-.57.14-.58.06-.46a12.77,12.77,0,0,0,.16-1.76c0-.55,0-1.1,0-1.6A54.93,54.93,0,0,0,193,225.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M185.23,202.27c-.44-1.75-1.72-1.75-4.44-.26-2.06,1.12-5,.11-6.33-.5a8.47,8.47,0,0,0,0,1.22s.13.86,4.68.66c1.52-.28,1.35,2,1.81,3.57.35,1.2.9-.67,2-2.2s2.14,1.39.76,2.26,1.07,4.58-3.05,6.21c1.78.81,5.78-.36,8.69-2.59,1.29-1,1.25-3.34.64-5.84C188,206.92,185.65,204,185.23,202.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M167.46,262.1v1.81a4.15,4.15,0,0,0,1.75,3.37c-1.45-4.29.25-6.14,2.32-6.14h34.12V258H171.58A4.13,4.13,0,0,0,167.46,262.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M206.86,271.1H172.79v2H206.1a5,5,0,0,1,4.32,4.33,4.13,4.13,0,0,0,.56-2v-.2A4.12,4.12,0,0,0,206.86,271.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M113.52,48.72c-2.39-4.33-12.64-3.93-12.64-3.93s-10.24-.4-12.63,3.93c-1.71,3.1,1.62,13.79,2.47,20.41a75.67,75.67,0,0,0,10.16,1.07A75.67,75.67,0,0,0,111,69.13C111.9,62.51,115.23,51.82,113.52,48.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M91.11,53.47c-1,.37-1.84,2.1-2.57,4.24.73,3.86,1.76,8.14,2.18,11.42a75.67,75.67,0,0,0,10.16,1.07A75.67,75.67,0,0,0,111,69.13c.25-1.92.71-4.18,1.19-6.49-1-.78-3.48-1.75-9.22-2.89C92.59,57.68,91.11,53.47,91.11,53.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M112.4,47.41s4,3.48,5.84,12.65c1.55,7.94-4.74,8.69-7.2,9.53-1.69.31-.32-4-.32-4L114,63.44s-2.61-7.28-3.38-10S112.4,47.41,112.4,47.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M114.86,63.1c-.77-.1-1.9-2.62-1.91-2.63.59,1.68,1,3,1,3l-3.28,2.18a15.75,15.75,0,0,0-.41,1.69,9.05,9.05,0,0,0,5-3.17C115.63,64,115.63,63.21,114.86,63.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M89.36,47.41s-4.06,3.48-5.85,12.65C82,68,88.25,68.75,90.71,69.59c1.7.31.32-4,.32-4l-3.27-2.18s2.6-7.28,3.37-10S89.36,47.41,89.36,47.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M86.9,63.1c.77-.1,1.9-2.62,1.9-2.63l-1,3L91,65.62a13.38,13.38,0,0,1,.41,1.69,9,9,0,0,1-5-3.17C86.13,64,86.13,63.21,86.9,63.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M117.28,97.86a4.24,4.24,0,0,0,2.85,3.31c2.61,1,4,.65,4.23,1.69s0,1.11,0,1.11a78,78,0,0,1-8.62,0c-1.78-.3-.67-5.8-.67-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M84.76,97.86a4.24,4.24,0,0,1-2.85,3.31c-2.61,1-4,.65-4.23,1.69s0,1.11,0,1.11a78,78,0,0,0,8.62,0c1.77-.3.67-5.8.67-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M118.76,76.28a6.44,6.44,0,0,0-4.16-5.7,39.8,39.8,0,0,0-4.83-1.45l-8.88-.93L92,69.13a39.8,39.8,0,0,0-4.83,1.45A6.42,6.42,0,0,0,83,76.28c-.31,6.31.37,17.84.59,22.44,1.36,1,3.86.66,3.86.66A80,80,0,0,0,89.83,83c.68-4.89,3.66-6.78,11.06-6.78s10.37,1.89,11,6.78a80,80,0,0,0,2.36,16.4s2.5.34,3.86-.66C118.38,94.12,119.06,82.59,118.76,76.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M103.09,44.61c-.73-.46-.91-2.7-.91-2.7s-1.87-.39-2.36,0a4.32,4.32,0,0,1-.86,2.7c-1.62,1.84.89,2.8,2.07,2.8s2.52-.63,2.79-1.45S103.09,44.61,103.09,44.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M99.82,41.91a3.51,3.51,0,0,1-.18,1.36,9.71,9.71,0,0,0,3.19,1.08,6.45,6.45,0,0,1-.65-2.44S100.31,41.52,99.82,41.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M105.68,32.52c-1.86-3.29-7.61-3.31-9.48,0-.82,1.45-.53,3.52-.1,5a8.26,8.26,0,0,0,3.8,5.1,2.89,2.89,0,0,0,1.93.11c2-.68,3.1-2.72,3.78-4.67.56-1.62.93-3.82.14-5.44C105.73,32.62,105.7,32.57,105.68,32.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M105.47,37.39s1.06-1.27,1.72-.51-.76,2.85-1.5,2.9S104.81,38.67,105.47,37.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M96.41,37.39s-1.06-1.27-1.72-.51.76,2.85,1.5,2.9S97.07,38.67,96.41,37.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M97.26,34s6.64,3.13,9.65,1.74c1.91-1,2.72-5,2-5.7s-1.33-.55-2.26-.44-1.68-1-2.2-1.62-.41-.17-1.45.35-2.46.07-3.66.26a5.3,5.3,0,0,0-4.19,4.22A7,7,0,0,0,95,36c.07.37,1.66,3.64,1.83,3.42C97.74,38.24,97.75,36.72,97.26,34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M104.67,34.87s-.77,3.61.38,4.54a8.91,8.91,0,0,0,1.43-4.22C106.48,33.87,104.67,34.87,104.67,34.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M102.16,38.93c-.2-.42-.7-1.26-1-1.75a.2.2,0,0,0-.36,0c-.22.72-.59,2.12-.27,2.19S102.46,39.56,102.16,38.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M106.91,35.75c1.32-.68,2.12-2.81,2.23-4.29-.57,1.25-1.87,3.24-4.09,3-3.15-.28-4.83-1.59-6.29-2s-2.51.44-2.64,2c-.08.91-.68,1-1.22.8A5,5,0,0,0,95,36c.07.37,1.66,3.64,1.83,3.42.92-1.16.93-2.68.44-5.39C97.26,34,103.9,37.14,106.91,35.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M114.46,96.74c-.84-1.12-.84-10.7-1.1-13.58s-.62-3.27.64-4.15-1.26-.72-2.3-.88-2.63-2-4.07-2.64-3.91-.64-3.34-1.28,2.22-.87,1.34-1.11-1.91-.88-.95-1.28,7-1.62,7-1.62c.16-.13.88-.11,1-.27-1.65-.52-2.93-.8-2.93-.8l-8.88-.93L92,69.13s-1.28.28-2.94.8c.13.16.84.14,1,.27,0,0,6.07,1.22,7,1.62s-.08,1-1,1.28.77.48,1.34,1.11-1.9.64-3.33,1.28-3,2.48-4.08,2.64-3.55,0-2.29.88.9,1.28.64,4.15-.26,12.46-1.1,13.58c-.56.74-2.25.78-3.75.86,0,.4,0,.78,0,1.12,1.36,1,3.86.66,3.86.66A80,80,0,0,0,89.83,83c.68-4.89,3.66-6.78,11.06-6.78s10.37,1.89,11,6.78a80,80,0,0,0,2.36,16.4s2.5.34,3.86-.66c0-.34,0-.72,0-1.12C116.71,97.52,115,97.48,114.46,96.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "111.3 70.2 90.47 70.2 88.41 58.09 113.36 58.09 111.3 70.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M102.94,64.84a2.52,2.52,0,0,1-4.11,0c-.33-.84.55-1.74,2-1.74S103.26,64,102.94,64.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M90.47,70.2h20.82l.22-1.24c-10.83.12-19-5.73-22.8-9.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 33.4,
    y: 172.97,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 33.51,
    y: 172.86,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 33.62,
    y: 172.75,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 33.73,
    y: 172.65,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 33.83,
    y: 172.54,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 33.94,
    y: 172.43,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 34.05,
    y: 172.32,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 34.16,
    y: 172.21,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 34.27,
    y: 172.11,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 34.37,
    y: 172,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 34.48,
    y: 171.89,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 34.59,
    y: 171.78,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 34.7,
    y: 171.67,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 34.81,
    y: 171.56,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 34.92,
    y: 171.46,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 35.02,
    y: 171.35,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 35.13,
    y: 171.24,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 35.24,
    y: 171.13,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 35.35,
    y: 171.02,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 35.46,
    y: 170.92,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 35.56,
    y: 170.81,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 35.67,
    y: 170.7,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 35.78,
    y: 170.59,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 35.89,
    y: 170.48,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 36,
    y: 170.38,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 36.11,
    y: 170.27,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 36.21,
    y: 170.16,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 36.32,
    y: 170.05,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 36.43,
    y: 169.94,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 36.54,
    y: 169.83,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 36.65,
    y: 169.73,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 36.75,
    y: 169.62,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 36.86,
    y: 169.51,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 36.97,
    y: 169.4,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 37.08,
    y: 169.29,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 37.19,
    y: 169.19,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 37.3,
    y: 169.08,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 37.4,
    y: 168.97,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 37.51,
    y: 168.86,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 37.62,
    y: 168.75,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 37.73,
    y: 168.64,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 37.84,
    y: 168.54,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.94,
    y: 168.43,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 38.05,
    y: 168.32,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 38.16,
    y: 168.21,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 38.27,
    y: 168.1,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 38.38,
    y: 168,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 38.49,
    y: 167.89,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 38.47,
    y: 167.89,
    width: 95.78,
    height: 65.4,
    rx: 6.37
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M127.87,167.89h-83a6.37,6.37,0,0,0-6.37,6.37v8.9h95.78v-8.9A6.38,6.38,0,0,0,127.87,167.89Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 56.5,
    cy: 175.52,
    r: 2.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M49.19,175.52A2.21,2.21,0,1,1,47,173.31,2.21,2.21,0,0,1,49.19,175.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M63.8,175.52A2.21,2.21,0,1,0,66,173.31,2.21,2.21,0,0,0,63.8,175.52Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 45.58,
    y: 192.4,
    width: 5.67,
    height: 26.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 54.69,
    y: 198.47,
    width: 5.67,
    height: 20.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 63.8,
    y: 195.32,
    width: 5.67,
    height: 23.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 72.92,
    y: 203.4,
    width: 5.67,
    height: 15.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M101.55,195.7a7,7,0,1,1-7-7A7.05,7.05,0,0,1,101.55,195.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 107.67,
    y: 194.49,
    width: 18.64,
    height: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 89.03,
    y: 205.25,
    width: 37.28,
    height: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 89.03,
    y: 210.72,
    width: 37.28,
    height: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 89.03,
    y: 216.19,
    width: 37.28,
    height: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 51.75,
    y: 224.58,
    width: 13.02,
    height: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 45.58,
    y: 223.38,
    width: 4.82,
    height: 4.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 75.65,
    y: 224.58,
    width: 13.02,
    height: 2.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 69.47,
    y: 223.38,
    width: 4.82,
    height: 4.82
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M287.44,285.22a3.1,3.1,0,0,1-2.37,3c-2.45.66-4.18.84-4.47,1.67s0,.84,0,.84,7.51,0,9-.48c.48-.77.3-5.07.3-5.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M303,285.19a2.52,2.52,0,0,1-1.72,3.08c-2.3.7-4,.92-4.11,1.75s.18.84.18.84,7.51-.16,8.9-.66c.31-.78-.79-5.06-.79-5.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M285.22,232.3s-1.58,28-1.06,33.47,2.91,20.07,2.91,20.07h3.26l-.85-20.93s2.57-14.07,3.68-16.48c2.15,4.29,3.54,17.44,3.54,17.44l5.82,20h3.77s-4.12-20.25-3.94-20.76,2-21.55-2.52-31.54C295.14,231.62,285.22,232.3,285.22,232.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M284.92,237.92c2.19,1,8,3.37,11.38,3.48s5.68,6.55,6.53,10.86c-.11-6-.72-12.93-2.6-17.76-3.53.3-9.61.86-10.76,1.21-1.63.5-3.48-2.63-3.91-2.34l-.41.23C285.09,234.59,285,236.09,284.92,237.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M312.28,237.6a13.47,13.47,0,0,1-2.23,3.09c-1.13,1,.57.56,1.52-.53.39-.39.52,1.27.09,1.79a11.86,11.86,0,0,1-1.65,1.3,4.27,4.27,0,0,0,2.17-.71c-.39.74-1.95,1.49-1.82,1.75s1.87.27,3.21-.86.7-5.13.61-5.61S312.28,237.6,312.28,237.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M282.14,190.81s2.83-.6,4.16-.83-.75-.52-2-.78c.09-.77,2.21-2.92,3-3.64s-.83-.14-1.78.71a7,7,0,0,1-.9.79s1.46-2.9,1.3-3.43-2.94,1-3.68,1.71-1.45,4-1.45,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314.21,219.77a11.4,11.4,0,0,0-.5-1.45,10,10,0,0,0-.84-1.53,23.59,23.59,0,0,0-1.62-2.11c-1.07-1.27-2.16-2.41-3.26-3.52s-2.06-2-3.11-3l-.07-.05c-1.84-2.83-11.05-2.51-11.05-2.51s-7.76.77-8.12.72c-1.3-.18-2.59-.4-3.82-.66,0-.08-3.53-1-3.78-1.11a1.79,1.79,0,0,1-.83-.43c-.5-.57.16-2.08.37-2.66a31.24,31.24,0,0,1,1.49-3.63,72.35,72.35,0,0,1,3.95-7.14l-2.51-1.89a78,78,0,0,0-5.26,6.84,35.12,35.12,0,0,0-2.3,3.84,11.85,11.85,0,0,0-1.53,5.16,5.45,5.45,0,0,0,.43,2.14,5.33,5.33,0,0,0,.68,1.08l.59.66a11.92,11.92,0,0,0,2.29,1.76,30.09,30.09,0,0,0,4.3,2.08c1.1.44,2.18.81,3.26,1.17.17,3.58,1.12,8.08,1.34,11.92.39,6.56.42,11.58.42,11.58s9.66,3.09,17,.2c.36-4,1.21-13.15,2.26-19.36.83.57,3.41,2.58,3.76,2.92s.21.25.34.35a6.12,6.12,0,0,1,.34.61,35.35,35.35,0,0,1,2,8c.46,2.87.8,5.81,1.05,8.72l3.14,0c.25-3,.41-6,.43-9.08A40.66,40.66,0,0,0,314.21,219.77Zm-37.13-15.41c0-.05,0-.14,0-.2a.2.2,0,0,1,0,.08C277.16,204.39,277.1,204.47,277.08,204.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M295.84,205.34a19.24,19.24,0,0,1-.18-3l-2.55.38s.05,2.31-1.32,3.3c-.41,1.84,1.62,2.33,3.58.66A1.47,1.47,0,0,0,295.84,205.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M293.8,207.63s-.32-1,.31-1.43,1.55-.86,1.75-1.45a1.85,1.85,0,0,1,.71,1.44c0,.47-2.05,2.42-2.05,2.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M292.54,205.2s-.42.89.19,1.34c.17.24.36,1.52-.33,1.93a4.44,4.44,0,0,1-1.27-2.07C291,205.65,292,205.09,292.54,205.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 293.22,
    cy: 211.01,
    r: 0.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-98",
    cx: 292.89,
    cy: 214.81,
    r: 0.59
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M283.49,210.66c-.12-.72-7.09.32-10.42-4a10.17,10.17,0,0,1-1.08-5.05,10.06,10.06,0,0,0-.57,3,5.45,5.45,0,0,0,.43,2.14,5.33,5.33,0,0,0,.68,1.08l.59.66a11.92,11.92,0,0,0,2.29,1.76,30.09,30.09,0,0,0,4.3,2.08c1.1.44,2.18.81,3.26,1.17A11.19,11.19,0,0,0,283.49,210.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M293.11,202.77a6.14,6.14,0,0,1-.2,1.49,4.87,4.87,0,0,0,2.83.33c-.1-1.06-.08-2.2-.08-2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M300.63,195.9a4.26,4.26,0,0,0-.91-1.63,4.62,4.62,0,0,0-3.85-1.57c-2.75.33-4.13,2.56-5.05,4.85s-1.56,3.75-.39,4.85,4.18.9,6.6.18A5.55,5.55,0,0,0,300.63,195.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M292.27,192.69s.05,2.85,4.94,4.59c.39.73-.47,2.36-1.89,2.87s.9.67,2,0,.94,1.18,0,1.32-2.09.93-1.85,1.49,2.21.72,4.51-1.19,3.31-5.05,2.86-6.68a6,6,0,0,0-2.65-2.93c-1.24-.84-2.69-1.26-3.9-2.14-.25-.18-.84-.57-.79,0,.1,1.06-.35.4-.91.07s-1.12-.4-1,.39-.1.39-.78.11S292.18,191.71,292.27,192.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M301.59,199.92a2,2,0,0,1-1.89-2.52c.52-1.33-.08-1.24-3.12-1.79-2.64-.48-4-3.72-4.28-4.58a5.69,5.69,0,0,0,0,1.66s.05,2.85,4.94,4.59c.39.73-.47,2.36-1.89,2.87s.9.67,2,0,.94,1.18,0,1.32-2.09.93-1.85,1.49,2.21.72,4.51-1.19A8.63,8.63,0,0,0,301.59,199.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M310,222.44c-.22-.89.73-1.9.68-2.35s-1.29.16-1.86-.51-4.26-5.84-4.43-5.36a6.65,6.65,0,0,0-2.06,4.2c-.4,2.87-1.24,9.8-2.48,10.92s-7.44,2.42-4.45,2.84,4.79,1.16,4.34,2.06-2.15,4.14-15.11,2.22V237s9.66,3.09,17,.2c.36-4,1.21-13.15,2.26-19.36l.21.15.06.05.2.14.08.06.26.19,0,0,.34.26h0c1.06.8,2.33,1.81,2.57,2s.21.25.34.35a4.6,4.6,0,0,1,.34.61,35.35,35.35,0,0,1,2,8c.4,2.47.69,5,.93,7.52,0,0,0,0,0-.06C311.6,233.62,310.24,223.34,310,222.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M288.72,260.88a5.17,5.17,0,0,1-2,3.91c-.19.28,1.58.75,2,2S290,278.76,290,278.78l-.56-13.87s2.57-14.07,3.68-16.48a26.32,26.32,0,0,1-2-2.55C290.49,244.85,289,258,288.72,260.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M50.71,297.72c-.66-1-4-.3-5.69-1.29-1.37-.78-1.29-2.9-1.29-2.9L41,293.11a30.54,30.54,0,0,0-.79,5.2,1.16,1.16,0,0,0,1,1.17,38.17,38.17,0,0,0,9.83.29A2.53,2.53,0,0,0,50.71,297.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M33.67,296.26c-.64-1-3.47-1-5.15-1.92-1.33-.75-.94-2.77-.94-2.77l-2.63-.4a19.92,19.92,0,0,0-1.11,5,1.14,1.14,0,0,0,1,1.13,83.86,83.86,0,0,0,9.17.95A2.46,2.46,0,0,0,33.67,296.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M47.31,271l-1.79-27.73L30,243a21.89,21.89,0,0,0-1.81,6.9c-.21,3.48.38,14.85.38,14.86l-.25,3.8.06-.36-4.1,23.72,3.35.8,7.08-23,.06-.36L37.07,254l3.77,17.59-.26,22.6,3.4.3,3.34-22.94,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M45.52,243.22,30.11,243H30a23.46,23.46,0,0,0-1.54,4.83c2.79.16,8,.26,10.49,1.9,3,2,6,6.71,7.62,9.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M34.06,257c-1.11,2.22-.2,9.39-1,10.56s-2.35.28-1.31,1.19S30,285,30,285h0l4.7-15.27.06-.36L37.07,254A6.57,6.57,0,0,0,34.06,257Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M43.1,197.28c-1.27-2-5-2.35-7.67-.38s-.55,7.19-.55,7.19c2.12,4.62,7.35,4.9,8.64,2.9S44.37,199.27,43.1,197.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M40.68,206.9s-.45,3.82.9,6a16.39,16.39,0,0,1-3.84-.07c-1.64-.3.54-7.15.54-7.15A3,3,0,0,1,40.68,206.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M41.76,193.36a16.17,16.17,0,0,0-6.66,1.27,4.31,4.31,0,0,0-2.52,4.48,18.26,18.26,0,0,0,2.61,7.54c1.51,2.17,5.77,2.76,6.3,1.53a3,3,0,0,0-1.1-3.29c-.83-.69.16-2.49.81-2s1,2.6,1.59,2-2.13-4.38-.44-4.57a4,4,0,0,0,2.84-2.29A7.64,7.64,0,0,0,46,195.4C46.27,193.09,43.26,193.42,41.76,193.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M36.16,209.9a3.55,3.55,0,0,1,2.47-.35,23.61,23.61,0,0,1,3,1l.69,2a18.71,18.71,0,0,0-4-.56C36.85,212.08,35.33,212.1,36.16,209.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M22.23,240.34a30.28,30.28,0,0,0,1.4,4.21c.47.74-.52.47-1.07-.47s-.67-.35-.62,0a20.6,20.6,0,0,1,.3,2.85c-.07.47-.35-.05-.56-.81s-.36-1.23-.36-1.23,0,2-.45,2.23-1.42-1.23-1.77-2.11,1.35-4.75,1.35-4.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M70.31,205.74s2.3-3.05,3.31-4.08,2.9-2.19,3.16-1.92-1.31,1.39-1.58,1.85.78.77,1.22,1.73a2,2,0,0,1-1,2.52c-.8.35-1.88.23-2.32.62s-1.27,1-1.27,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M70.69,205c-2.22,1.95-4.19,4.12-6.47,6-1.14.93-2.29,1.86-3.44,2.72-.57.43-1.15.85-1.71,1.23a8.71,8.71,0,0,1-.8.49c-.1.05-.28.18-.32.17l-.11,0c-.13-.07-.71,0-1.35-.07s-1.31-.1-2-.17c-1.37-.16-2.8-.39-4.21-.64-.91-.16-9.41-3.41-11.1-3.7A5.56,5.56,0,0,0,38,211c-3.56.2-5.95.93-7.36,2.25a3.73,3.73,0,0,0-.79.75c-.75,1-1.5,2-2.24,3a77.79,77.79,0,0,0-4.75,7,15,15,0,0,0-1.77,4.45,37,37,0,0,0-.67,4.25,81.57,81.57,0,0,0-.39,8.24l2.52.22a77,77,0,0,1,1.9-7.65,30.61,30.61,0,0,1,1.3-3.54,9.22,9.22,0,0,1,1.78-2.72c.48-.54,1-1.08,1.52-1.62-.17,6.77-.66,15.15-.83,20.44,7.42,2.8,17.93.73,17.93.73s.11-12.4,1.32-17a50.43,50.43,0,0,0,1.36-7.26l1,0c1.55-.09,3.09-.18,4.69-.36.8-.09,1.59-.18,2.46-.34a12.65,12.65,0,0,0,3-.85,8.68,8.68,0,0,0,.87-.52,5.56,5.56,0,0,0,.59-.46,12,12,0,0,0,1-.87c.59-.57,1.13-1.13,1.65-1.7,1-1.13,2-2.27,3-3.41,2-2.3,3.85-4.61,5.72-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M39.23,199.11c-1.74.44-.73,4.17-2.95,4.19a7.87,7.87,0,0,1-2.79-.24,15.25,15.25,0,0,0,1.7,3.59c1.51,2.17,5.77,2.76,6.3,1.53a3,3,0,0,0-1.1-3.29c-.83-.69.16-2.49.81-2s1,2.6,1.59,2-2.13-4.38-.44-4.57a4,4,0,0,0,2.84-2.29A7.64,7.64,0,0,0,46,195.4S44.86,199,39.23,199.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M59.59,218.91a41.12,41.12,0,0,1-12.25.79c-2.77.67-2.65,5.94-3.05,12.88s-.77,7-2.71,7.65-1.75,1.77,0,2S39.76,247,28.23,245c0,.34,0,.66,0,1,7.42,2.8,17.93.73,17.93.73s.11-12.4,1.32-17a50.43,50.43,0,0,0,1.36-7.26l1,0c1.55-.09,3.09-.18,4.69-.36.8-.09,1.59-.18,2.46-.34a12.65,12.65,0,0,0,3-.85,8.68,8.68,0,0,0,.87-.52,5.56,5.56,0,0,0,.59-.46,12,12,0,0,0,1-.87c.59-.57,1.13-1.13,1.65-1.7,1-1.13,2-2.27,3-3.41.62-.73,1.23-1.47,1.84-2.2C68.44,212.18,61.53,218.37,59.59,218.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M24.29,227.34c-.45,1.59-1.15,10.91-1.15,10.91l0-.06c.38-1.61.78-3.21,1.26-4.75a30.61,30.61,0,0,1,1.3-3.54,9.22,9.22,0,0,1,1.78-2.72c.48-.54,1-1.08,1.52-1.62,0,0,.9-6,1-6.71S24.75,225.75,24.29,227.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 103.22,
    y: 132.15,
    width: 17.43,
    height: 1.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 102.87,
    y: 122.45,
    width: 17.43,
    height: 4.21
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMock2);
export default __webpack_public_path__ + "static/media/mock-2.9d00b410e207ea8db29b0b3e8123f991.svg";
export { ForwardRef as ReactComponent };